import { NimbuxHotelMedia } from "@bandido/shared/interfaces";
import { Box } from "@mui/material";
import { ImageTile, SortableImageTile } from "./ImageTile";
import { useResponsiveCols } from "./hooks";

type ResponsiveImageListProps = {
  items: NimbuxHotelMedia[];
  selectable?: boolean;
  selectedIds?: Set<string>;
  onToggleSelect?: (id: string) => void;
  enableSorting?: boolean;
  renderBadge?: (img: NimbuxHotelMedia) => React.ReactNode | null;
  singleColumn?: boolean;
};

export const ImageList = ({
  items,
  selectable,
  selectedIds,
  onToggleSelect,
  enableSorting,
  renderBadge,
  singleColumn = false,
}: ResponsiveImageListProps) => {
  const cols = useResponsiveCols();
  return (
    <Box 
      sx={{ 
        display: 'grid',
        gridTemplateColumns: `repeat(${singleColumn ? 1 : cols}, 1fr)`,
        gap: 1,
        m: 0,
        width: '100%'
      }}
    >
      {items.map((img) =>
        enableSorting ? (
          <SortableImageTile
            key={img.url || 0}
            img={img}
            selectable={!!selectable}
            selected={!!selectedIds?.has(img.url)}
            onToggle={() => onToggleSelect?.(img.url)}
            renderBadge={renderBadge}
          />
        ) : (
          <ImageTile
            key={img.url || 0}
            img={img}
            selectable={!!selectable}
            selected={!!selectedIds?.has(img.url)}
            onToggle={() => onToggleSelect?.(img.url)}
            renderBadge={renderBadge}
          />
        )
      )}
    </Box>
  );
}
